import { getAuthHeaders } from './authService';
import { captureParams } from './inventoryIdentity';

const base = `${(process.env.REACT_APP_API_URL || '/api').replace(/\/$/, '')}/v2/inventario`;

async function checkedResponse(path, signal) {
  const response = await fetch(`${base}${path}`, { headers: getAuthHeaders(), signal });
  if (!response.ok) {
    const data = await response.json().catch(() => null);
    throw new Error(data?.detail || `No se pudo consultar el inventario (HTTP ${response.status}).`);
  }
  return response;
}

export async function loadClientInventory(sapIds, signal) {
  const params = new URLSearchParams();
  sapIds.forEach(id => params.append('sap_id', id));
  const response = await checkedResponse(`/clientes/resumen?${params}`, signal);
  const data = await response.json();
  if (!Array.isArray(data?.inventarios)) throw new Error('El resumen del cliente tiene un formato inválido.');
  return data.inventarios;
}

export async function loadInventoryDrive(id, signal, inventory) {
  const query = captureParams(inventory).toString();
  const response = await checkedResponse(`/${id}/drive${query ? `?${query}` : ''}`, signal);
  const data = await response.json();
  if (!Array.isArray(data?.files)) throw new Error('La lista de archivos de Drive tiene un formato inválido.');
  return data;
}

export async function downloadInventory(id, signal, inventory) {
  const query = captureParams(inventory).toString();
  const response = await checkedResponse(`/${id}/descarga${query ? `?${query}` : ''}`, signal);
  const blob = await response.blob();
  const disposition = response.headers.get('Content-Disposition') || '';
  const encoded = disposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1];
  const filename = encoded ? decodeURIComponent(encoded) : `inventario-${id}.zip`;
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  try {
    link.click();
  } finally {
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
}
